import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  date: "",
  clientName: "",
  clientAddress: "",
  passportNumber: "",

  clientEmail: "",
  bookingNumber: "",
  clientBirthDate: "",
  familyMembers: [],
  flightDetails: [],
};

const claimFormSlice = createSlice({
  name: "claimForm",
  initialState,
  reducers: {
    setClaimFormData: (state, action) => {
      return { ...state, ...action.payload };
    },
    removeClaimFormTraveler: (state, action) => {
      const index = action.payload;
      state.familyMembers = state.familyMembers.filter((_, i) => i !== index);
    },
    removeFlightDetail: (state, action) => {
      const index = action.payload;
      state.flightDetails = state.flightDetails.filter((_, i) => i !== index);
    },
  },
});

export const { setClaimFormData, removeClaimFormTraveler, removeFlightDetail } =
  claimFormSlice.actions;

export default claimFormSlice.reducer;
